import React, { useState, useEffect } from 'react';
import { PrivateAxiosInstance } from '../../services/createAxiosInstance';
import { URLs } from '../../constants/apiEndpoints';
import Pagination from '../../components/Pagination/Pagination';
import { useNavigate } from 'react-router-dom';
import { message, Spin } from 'antd';
import moment from 'moment';

function MarketAnalysisPage() {
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null);

  const navigate = useNavigate();

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const fetchData = async (
    page = 1,
    limit = 20,
    sortOrder = 'desc',
    searchValue = ''
  ) => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        page: String(page),
        limit: '10',
        status: false,
        sortOrder: sortOrder,
        search: searchValue,
      }).toString();

      const res = await PrivateAxiosInstance.get(
        `${URLs.GET_ALL_ARTICLES}?${queryParams}`
      );
      const data = res?.data?.articles;
      const totalPage = res?.data?.pages;

      setFilteredData(data);
      setTotalPages(totalPage);
    } catch (error) {
      console.error('Error fetching articles:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage, 15, 'desc', searchText);
  }, [currentPage, searchText]);

  const handleReadMoreClick = (articleId) => {
    console.log('Read more clicked for article:', articleId);
    navigate(`/market-analysis/article/${articleId}`);
  };

  return (
    <>
      <Spin spinning={loading} fullscreen />
      <h5 className="mb-5 text-xl md:text-3xl font-bold tracking-tight font-poppins text-gray-300  mt-[15px] md:mt-[90px]">
        Market Analysis
      </h5>
      <div className="grid grid-cols-1 gap-4">
        {filteredData?.map((item, index) => (
          <div
            key={index}
            className="flex flex-col font-poppins items-center bg-background-secondary-color border border-neutral-800 rounded-lg shadow md:flex-row md:max-w-8xl "
          >
            <img
              className="object-cover w-full rounded-lg p-4 max-h-96 md:max-h-96 md:max-w-64 md:rounded-none md:rounded-s-lg"
              src={item.image[0]?.url}
              alt={item.image[0]?.imageName}
            />
            <div className="flex flex-col p-4 leading-normal">
              <p className="mb-1 line-clamp-3 text-start font-normal text-sm text-gray-400 ">
                {moment(item?.createdAt).fromNow()}
              </p>
              <h5 className="mb-2 line-clamp-3 text-start text-xl md:text-2xl font-bold tracking-tight font-poppins text-gray-200 ">
                {item.articleName}
              </h5>
              <div className="mb-3 font-poppins text-gray-100 line-clamp-3">
                {item?.description
                  ? item?.description.replace(/<[^>]+>/g, '')
                  : ''}
              </div>

              <p
                className="mb-3 line-clamp-3 cursor-pointer text-start text-sm font-normal text-btn-color"
                onClick={() => handleReadMoreClick(item.articleId)}
              >
                Read more...
              </p>
            </div>
          </div>
        ))}
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </>
  );
}

export default MarketAnalysisPage;
